import { ReactElement } from 'react';

import { styled } from '../../../../styled';
import { Theme } from '../../../../theme/interface/detailed';

type Interface = { className: string; avatarUrl: string };

export const Component = ({ className, avatarUrl }: Interface): ReactElement => (
	<img src={avatarUrl} className={className} alt="agent img" />
);

const AgentAvatar = styled(Component)(
	({
		theme: {
			chat: {
				header: { agentAvatar },
			},
		},
	}: {
		theme: Theme;
	}) => agentAvatar
);

export { AgentAvatar };
